var giphy_viewer_default = {
  "giphyWrapper": "C1NZK",
  "giphy_player": "B-z-L",
  "playIcon": "kemLJ",
  "gifRatio": "g42Hs"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
